<template>
  <div>
    <b-alert show variant="warning">
      <h4 class="alert-heading">Oops!</h4>
      <p>
        There was a problem with your rmCloud license.  Please try installing the add-on again or asking your adminstrator.
      </p>
    </b-alert>
  </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// MissingLicense.vue?724b1692